/**
 * TKT #274563 · Custom Capacitor bridge for DIRECT native Google Sign-In.
 *
 * iOS     → Google Sign-In SDK (GoogleSignIn 9.2.0), custom-nonce sign-in.
 * Android → Credential Manager / Sign in with Google (GetGoogleIdOption),
 *           nonce-bearing Google ID token.
 *
 * The native nonce is passed VERBATIM (no SHA-256 transform): the pinned
 * GoogleSignIn-iOS 9.2.0 source forwards `options.nonce` straight into the
 * OIDAuthorizationRequest, and Credential Manager echoes `setNonce` as-is, so
 * the id_token `nonce` claim carries the raw server nonce on BOTH platforms.
 * (The SHA-256 convention is Firebase's, not the SDK's.)
 *
 * Native interface:
 *   signIn({ nonce, serverClientId, filterByAuthorizedAccounts }) -> { idToken }
 *   signOut() -> void
 *   disconnect() -> void   // account deletion only (revokes the Google grant)
 */
import { registerPlugin } from "@capacitor/core";

export const CruiseGoogleAuth = registerPlugin("CruiseGoogleAuth");

// Web/server OAuth client ID (Android `serverClientId`; iOS also reads
// GIDServerClientID from Info.plist). Supplied at build time; never a secret.
export const GOOGLE_SERVER_CLIENT_ID = process.env.REACT_APP_GOOGLE_SERVER_CLIENT_ID || "";
